/* Seat cap per course. Loads before sfg-group.js. */
(function () {
  var CAP = 25;
  var C = window.SFG || {};
  /* Only show prices up to the cap: drop 30-49 and 50+ tiers, cap the 20+ tier at 25. */
  (C.courses || []).forEach(function (c) {
    if (!c.tiers) return;
    c.tiers = c.tiers.filter(function (t) { return t.min <= CAP; });
    var last = c.tiers[c.tiers.length - 1];
    if (last && (last.max === null || last.max > CAP)) last.max = CAP;
  });
  var hit = false;
  function track(ev) { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: ev }); }
  function showCap() {
    var p = document.getElementById('sfg-cap'); if (p) p.hidden = false;
    if (!hit) { hit = true; track('group_cap_hit'); }
  }
  /* + button at the cap: stop, show the note */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-step="1"]') : null; if (!b) return;
    var inp = document.querySelector('input[data-key="' + b.getAttribute('data-key') + '"]');
    if ((parseInt(inp && inp.value, 10) || 0) >= CAP) { e.preventDefault(); e.stopImmediatePropagation(); showCap(); }
  }, true);
  /* typed numbers over the cap snap back to 25 */
  document.addEventListener('input', function (e) {
    var el = e.target; if (el.tagName !== 'INPUT' || !el.hasAttribute('data-key')) return;
    if ((parseInt(el.value, 10) || 0) > CAP) { el.value = CAP; showCap(); }
  }, true);
})();
